import MainLayout from "../components/layouts/MainLayout";
import {getCookiePreferences} from "../helpers/cookies";
import localized from "../locale/locales";
import {useRouter} from "next/router";
import Hero from "../components/Hero";
import Title from "../components/Title";
import Container from "../components/Container";
import FaqItem from "../components/FaqItem";
import {useMemo, useState} from "react";
import {stripHtml} from "../helpers/strings";

function getSchemaData(items) {
    const schema = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": []
    };

    items.forEach(item => {
        schema.mainEntity.push({
            "@type": "Question",
            "name": stripHtml(item.question),
            "acceptedAnswer": {
                "@type": "Answer",
                "text": stripHtml(item.answer)
            }
        });
    });

    return schema;
}

export default function Faq({hasCookiePreferences, cookiePreferences}) {
    const {locale} = useRouter();
    const [activeFaq, setActiveFaq] = useState(null);
    const {faq: lang, og} = localized[locale];

    const schemaData = useMemo(() => {
        JSON.stringify(getSchemaData(lang.items))
    }, [lang.items]);

    return (
        <MainLayout hasCookiePreferences={hasCookiePreferences}
                    cookiePreferences={cookiePreferences}
                    footerTheme="dark"
                    title={lang.og?.title || lang.title}
        >
            <Hero size="narrow" bgPosition="center" image="faq">
                <div className="flex flex-col gap-4 max-w-[22rem]">
                    <header>
                        <Title Elem="h1">{lang.title}</Title>
                    </header>
                </div>
            </Hero>

            <Container className="py-8 md:py-12 lg:py-20">
                <div className="flex flex-col gap-7 items-center">
                    {lang.items.map((item, key) => {
                        return (
                            <FaqItem key={`FaqItem: ${key}`}
                                     onClick={() => setActiveFaq(key !== activeFaq ? key : null)}
                                     isOpen={key === activeFaq}
                                     {...item}
                            />
                        )
                    })}
                </div>
            </Container>
            <script type="application/ld+json">
                {schemaData}
            </script>
        </MainLayout>
    )
}


export async function getServerSideProps({req, res}) {
    const cookiePreferences = getCookiePreferences(req);

    return {
        props: {
            ...cookiePreferences
        }
    }
}
